var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownArrowNoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.43662 8.29473L16.7241 1.00723C16.9575 0.773893 17.2325 0.659309 17.5491 0.663475C17.8658 0.667643 18.1408 0.786392 18.3741 1.01973C18.6075 1.25306 18.7241 1.52806 18.7241 1.84473C18.7241 2.16139 18.6075 2.43639 18.3741 2.66973L10.7616 10.2947C10.57 10.4864 10.3616 10.626 10.1366 10.7135C9.91162 10.801 9.67829 10.8447 9.43662 10.8447C9.19495 10.8447 8.96162 10.801 8.73662 10.7135C8.51162 10.626 8.30329 10.4864 8.11162 10.2947L0.486621 2.66973C0.253287 2.43639 0.138704 2.15931 0.14287 1.83848C0.147037 1.51764 0.265787 1.24056 0.49912 1.00723C0.732454 0.773893 1.00745 0.657227 1.32412 0.657227C1.64079 0.657226 1.91579 0.773893 2.14912 1.00723L9.43662 8.29473Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownArrowNoColor);
export default __webpack_public_path__ + "static/media/dropDownArrowNoColor.47a35d035fe3cdc43bb3369a9d6da5ed.svg";
export { ForwardRef as ReactComponent };